function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M15.6656364,4.21768548 C16,5.44312097 16,8 16,8 C16,8 16,10.5567903 15.6656364,11.7824032 C15.4816364,12.4584597 14.9395455,12.9908952 14.2510909,13.1716855 C13.0033636,13.5 8,13.5 8,13.5 C8,13.5 2.99663636,13.5 1.74890909,13.1716855 C1.06054545,12.9908952 0.518363636,12.4584597 0.334363636,11.7824032 C0,10.5567903 0,8 0,8 C0,8 0,5.44312097 0.334363636,4.21768548 C0.518363636,3.54154032 1.06054545,3.00910484 1.74890909,2.82840323 C2.99663636,2.5 8,2.5 8,2.5 C8,2.5 13.0033636,2.5 14.2510909,2.82840323 C14.9395455,3.00910484 15.4816364,3.54154032 15.6656364,4.21768548 Z M6.36363636,10.3214435 L10.5454545,8.00008871 L6.36363636,5.67855645 L6.36363636,10.3214435 Z"
});

var SvgYouTube = function SvgYouTube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYouTube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/YouTube.d5744175.svg";
export { ForwardRef as ReactComponent };